import {
    FGAppSwitcherModule,
    FGButton,
    FGDropdownMenu,
    FGDropdownMenuDivider,
    FGDropdownMenuListContent,
    FGDropdownMenuListItem,
    FGHeader,
    FGIcons,
    FGStack,
    FGTypography,
} from '@fg/design-system';
import { useMemo } from 'react';
import Logo from 'assets/general/Logo_BMI_Geo_Risk_Signals_White.svg';
import { DEFAULT_VIEWS } from 'interfaces';
import { getUserAppSwitcherOptions } from 'utils/fitchAppSwitcherUtils';
import { IMobxRootState } from 'RootStore';
import { inject } from 'mobx-react';
import APIService from 'services/APIService';
import { shouldShowStagingIndicator } from 'services/configService';
import { isEmpty } from 'lodash/fp';
import React from 'react';


type Props = {
    username?: string;
    accessibleApps?: string[];
};

const IS_CUSTOM_VIEWS_VISIBLED = false;

export const Header = inject(({ UserStore }: IMobxRootState) => {
    return {
            username: UserStore?.username,
            accessibleApps: UserStore?.accessible_apps,
    };
})(({ username, accessibleApps }: Props) => {
    const appSwitchOptions = useMemo(
        () => getUserAppSwitcherOptions(accessibleApps),
        []
    );

    return (
        <FGHeader
            left={
                <FGStack direction="row" alignItems="center" gap={8}>
                    <img
                        alt="BMI Geo Risk Signals"
                        title="BMI Geo Risk Signals"
                        style={{
                            cursor: 'pointer',
                            height: 28,
                            width: 183,
                            minWidth: 183,
                        }}
                        src={Logo}
                        onClick={() =>
                            (window.location.href = `/#/${DEFAULT_VIEWS.HOME}`)
                        }
                    />
                    {shouldShowStagingIndicator() && <StagingBadge />}
                </FGStack>
            }
            right={
                <>
                    {!isEmpty(appSwitchOptions) && (
                        <FGAppSwitcherModule
                            options={appSwitchOptions}
                            appendTo={'parent'}
                            isEmpty={isEmpty(appSwitchOptions)}
                            triggerElement={<FGIcons icon="AppSwitcher" />}
                        />
                    )}
                    <FGDropdownMenu
                        trigger="click"
                        triggerElement={
                            <FGButton aria-label="User account" variant="ghost">
                                <FGIcons icon="Profile" />
                            </FGButton>
                        }>
                        <FGDropdownMenuListContent>
                            <FGDropdownMenuListItem>
                                <FGTypography
                                    variant="body3-short"
                                    tag="label"
                                    color="neutral">
                                    {username}
                                </FGTypography>
                            </FGDropdownMenuListItem>
                            {IS_CUSTOM_VIEWS_VISIBLED && (
                                <>
                                    <FGDropdownMenuDivider />
                                    <FGDropdownMenuListItem>
                                        <MenuButton
                                            icon="Topics"
                                            label="Custom Weights"
                                        />
                                    </FGDropdownMenuListItem>
                                    <FGDropdownMenuListItem>
                                        <MenuButton
                                            icon="Americas"
                                            label="Country Groups"
                                        />
                                    </FGDropdownMenuListItem>
                                </>
                            )}
                            <FGDropdownMenuDivider />
                            <FGDropdownMenuListItem>
                                <MenuButton
                                    icon="WatchNegative"
                                    label="Log out"
                                    onClick={() => {
                                        APIService.logout().then(response => {
                                            window.location.href =
                                                response?.data?.redirectUrl;
                                        });
                                    }}
                                />
                            </FGDropdownMenuListItem>
                        </FGDropdownMenuListContent>
                    </FGDropdownMenu>
                </>
            }
        />
    );
});

export default Header;


const StagingBadge = React.memo(() => (
    <span
        title="You are on a staging environment, not production"
        style={{
            backgroundColor: '#d32f2f',
            color: '#fff',
            fontSize: 11,
            fontWeight: 700,
            lineHeight: 1,
            letterSpacing: '0.5px',
            padding: '4px 6px',
            borderRadius: 4,
            whiteSpace: 'nowrap',
        }}>
        STG
    </span>
));


const MenuButton = React.memo(
    ({
        onClick,
        icon,
        label,
    }: {
        onClick?: () => void;
        icon: string;
        label: string;
    }) => (
        <FGButton
            variant="ghost"
            onClick={onClick}
            style={{
                width: '100%',
                padding: 8,
                whiteSpace: 'nowrap',
                justifyContent: 'space-between',
            }}>
            <FGStack
                alignItems="center"
                justifyContent="flex-start"
                gap={8}
                style={{ width: '100%', pointerEvents: 'none' }}>
                {/* @ts-ignore */}
                <FGIcons icon={icon} />
                <FGTypography variant="body3-short" tag="label" color="strong">
                    {label}
                </FGTypography>
            </FGStack>
        </FGButton>
    )
);